import { createSlice } from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/MemberUIHelpers";

const initialMembersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  memberForEdit: null,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const memberSlice = createSlice({
  name: "members",
  initialState: initialMembersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getMemberById
    memberFetched: (state, action) => {
      state.actionsLoading = false;
      state.memberForEdit = action.payload.memberForEdit;
      state.error = null;
    },
    // findMembers
    membersFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // allMembers
    memberALlFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.allData = action.payload.allData;
    },
    // createMember
    // memberCreated: (state, action) => {
    //   state.ewactionsLoading = false;
    //   state.error = null;
    //   state.entities.push(action.payload.member);
    // },
    // updateMember
    memberUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity.id === action.payload.member.id) {
      //     return action.payload.member;
      //   }
      //   return entity;
      // });
    },
    memberFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  },
});
